import qs from 'qs';
import agileBilling from '../apis/agileBilling';
import hacienda from '../apis/hacienda';
import tipoCambio from '../apis/tipoCambio';
import validarExoneracion from '../apis/validarExoneracion';
import { actionTypesEnum, cabysCategoriasEnum } from '../enum';
import { getErrorMessage } from '../util';

// LOCAL FORM
export const setLocalForm = (formValues) => async dispatch => {
  dispatch({ type: actionTypesEnum.localForm, payload: formValues });
};

// LOGIN
export const getLogin = (formValues) => async dispatch => {
  dispatch({ type: actionTypesEnum.loading, payload: true });
  const data = qs.stringify({ password: formValues.Password, grant_type: 'password', username: formValues.Usuario });
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  };

  try {
    const response = await agileBilling.post('/token', data, headers)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: getErrorMessage(err.response.status, 'token') } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      sessionStorage.setItem('token', qs.stringify({ token: response.data, expireDate: new Date() }));
      dispatch({ type: actionTypesEnum.getToken, payload: { token: response.data, expireDate: new Date() } });
      getEmisor(response.data.access_token, data.Usuario);
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }
};

export const logOut = () => dispatch => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('emisor');
  dispatch({ type: actionTypesEnum.getToken, payload: null });
  dispatch({ type: actionTypesEnum.getEmisor, payload: null });
}

export const clearErrors = () => dispatch => {
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });
}

export const clearErrorsNuevoDocumento = () => dispatch => {
  dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: null, message: '' } });
}

export const setError = (menssaje, tipoError) => dispatch => {
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: tipoError, message: menssaje } });
}

export const setInicializarDocumento = (clearAll = true) => dispatch => {
  if (clearAll) {
    dispatch({ type: actionTypesEnum.tipoCambioDolar, payload: { tipoCambioDolar: null } });
    dispatch({ type: actionTypesEnum.getAllActividades, payload: { allActividades: null } });
    dispatch({ type: actionTypesEnum.duplicarFactura, payload: null });
    dispatch({ type: actionTypesEnum.getExoneracion, payload: null });
    dispatch({ type: actionTypesEnum.localForm, payload: null });
    dispatch({ type: actionTypesEnum.getReceptorHacienda, payload: null });
  } else {
    dispatch({ type: actionTypesEnum.tipoCambioDolar, payload: { tipoCambioDolar: null } });
    dispatch({ type: actionTypesEnum.localForm, payload: null });
  }

  dispatch(clearErrors());
  dispatch(clearErrorsNuevoDocumento());
}

// EMISOR
export const getEmisor = (token, userName) => async dispatch => {

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };
  dispatch({ type: actionTypesEnum.loading, payload: true });
  try {
    const response = await agileBilling.get(`/emisores/getEmisorByUserName/0?userName=${userName}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: getErrorMessage(err.response.status, 'emisor') } });
        }
      });

    if (response) {
      sessionStorage.setItem('emisor', qs.stringify({ emisor: { ...response.data, usuario: userName } }));
      dispatch({ type: actionTypesEnum.getEmisor, payload: { emisor: { ...response.data, usuario: userName } } });
    }

  } catch (err) {
    console.log(err);
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const postEmisor = (token, emisor) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await agileBilling.post(`/emisores/`, emisor, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, 'emisor') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getErrores, payload: { error: false, message: 'La información se guardo con éxito' } });
    }

  } catch (err) {
    console.log(err);
  }

};

// DIRECCION
export const getCantones = (token, provinciaId) => async dispatch => {

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.get(`/catalogos/cantones/${provinciaId}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: getErrorMessage(err.response.status, 'cantones') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getCantones, payload: { cantones: response.data } });
    }

  } catch (err) {
    console.log(err);
  }

  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const getDistritos = (token, provinciaId, cantonId) => async dispatch => {

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.get(`/catalogos/distritos/${provinciaId}/${cantonId}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: getErrorMessage(err.response.status, 'distritos') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getDistritos, payload: { distritos: response.data } });
    }

  } catch (err) {
    console.log(err);
  }

  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const getBarrios = (token, provinciaId, cantonId, distritoId) => async dispatch => {

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.get(`/catalogos/barrios/${provinciaId}/${cantonId}/${distritoId}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: getErrorMessage(err.response.status, 'barrios') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getBarrios, payload: { barrios: response.data } });
    }

  } catch (err) {
    console.log(err);
  }

  dispatch({ type: actionTypesEnum.loading, payload: false });
};

// ACTIVIDADES
export const getAllActividades = (token) => async dispatch => {

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  try {
    const response = await agileBilling.get('/catalogos/actividadeconomica', config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: getErrorMessage(err.response.status, 'actividades') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getAllActividades, payload: { allActividades: response.data } });
    }

  } catch (err) {
    console.log(err);
  }
};

export const getActividadesHacienda = (token, cedula) => async dispatch => {

  dispatch({ type: actionTypesEnum.loading, payload: true });

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 5000
  };

  try {
    const response = await hacienda.get(`/fe/ae?identificacion=${cedula}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch(getActividades(token, cedula));
        }
      });

    if (response) {
      const actividades = response.data?.actividades?.map(x => {
        return { CodigoActividad: x.codigo, Actividad: `${x.codigo} - ${x.descripcion}` };
      });
      dispatch({ type: actionTypesEnum.getActividades, payload: { actividades: actividades } });
    }

  } catch (err) {
    console.log(err);
  }

  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const getActividades = (token, cedula) => async dispatch => {

  dispatch({ type: actionTypesEnum.loading, payload: true });

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  try {
    const response = await agileBilling.get(`/GetActividadEconomicaPorEmisor/${cedula}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: getErrorMessage(err.response.status, 'actividades económicas') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getActividades, payload: { actividades: response.data } });
    }

  } catch (err) {
    console.log(err);
  }

  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const postActividades = (token, actividadesPorEmisor) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await agileBilling.post(`/AgregarActividadEconomica`, actividadesPorEmisor, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getEmisor, payload: { emisor: response.data } });
    }

  } catch (err) {
    console.log(err);
  }

};

// Inventario
export const getCabys = (token, codigo, categoria, frase = null) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };
  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  const pameter = frase === null ? `${codigo}/${categoria}` : `${codigo}/${categoria}/${frase}`;
  try {
    const response = await agileBilling.get(`/inventario/cabys/${pameter}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      switch (categoria) {
        case 'CAT1':
          dispatch({ type: actionTypesEnum.getCabys, payload: { Cat1: response.data } });
          break;
        case cabysCategoriasEnum.cat3:
          dispatch({ type: actionTypesEnum.getCabys, payload: { Cat3: response.data } });
          break;
        case cabysCategoriasEnum.cat6:
          dispatch({ type: actionTypesEnum.getCabys, payload: { Cat6: response.data } });
          break;
        case cabysCategoriasEnum.pri:
          dispatch({ type: actionTypesEnum.getCabys, payload: { Pri: response.data } });
          break;
      }

    }

  } catch (err) {
    console.log(err);
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const getInventario = (token, emisorId, pageSize, pageNumber, frase = null) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };
  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: 'getInventario' } });

  const pameter = frase === null ? `${emisorId}/${pageSize}/${pageNumber}` : `${emisorId}/${pageSize}/${pageNumber}/${frase}`;
  try {
    const response = await agileBilling.get(`/inventario/productos/${pameter}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getInventario, payload: { ...response.data } });
    }

  } catch (err) {
    console.log(err);
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const postInventario = (token, producto) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };
  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await agileBilling.post(`/inventario`, producto, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getErrores, payload: { error: false, message: 'La información se guardo con éxito' } });
    }

  } catch (err) {
    console.log(err);
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const putInventario = (token, producto) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };
  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: 'putInventario' } });

  try {
    const response = await agileBilling.post(`/inventario/update`, producto, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getErrores, payload: { error: false, message: 'La información se guardo con éxito' } });
    }

  } catch (err) {
    console.log(err);
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const deleteInventario = (token, id) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: 'deleteInventario' } });

  try {
    const response = await agileBilling.get(`/inventario/delete/${id}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getErrores, payload: { error: false, message: 'Producto elminado' } });
    }

  } catch (err) {
    console.log(err);
  }

};

// FACTURAS
export const postFacturaPorEmisor = (token, filter) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await agileBilling.post(`/FacturaPorEmisor`, filter, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        console.log(err.response.data);
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getFacturaPorEmisor, payload: { facturas: response.data } });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    console.log(err);
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }

};

// TIPO DE CAMBIO MONEDA
export const getTipoCambioDolar = (day, month, year, newRequest) => async dispatch => {
  const config = {
    headers: { 'Content-Type': 'application/json' }
  };

  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {

    if (!newRequest) {
      dispatch({ type: actionTypesEnum.tipoCambioDolar, payload: { tipoCambioDolar: null } });
    }
    else {
      const response = await tipoCambio.get(`/${day}/${month}/${year}`, config)
        .catch(err => {
          if (err?.response) {
            dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
          }
          console.log(err.response.data);
        });

      if (response) {
        dispatch({ type: actionTypesEnum.tipoCambioDolar, payload: { tipoCambioDolar: response.data } });
      }
    }
  } catch (err) {
    console.log(err);
  }

};

// TIPO DE CAMBIO MONEDA
export const getExoneracion = (documento) => async dispatch => {
  const config = {
    headers: { 'Content-Type': 'application/json' }
  };

  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {

    if (!documento) {
      dispatch({ type: actionTypesEnum.getExoneracion, payload: { exoneracion: null } });
    }
    else {
      const response = await validarExoneracion.get(`fe/ex?autorizacion=${documento}`, config)
        .catch(err => {
          if (err?.response) {
            dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
          }
          console.log(err.response.data);
        });

      if (response) {
        dispatch({ type: actionTypesEnum.getExoneracion, payload: { exoneracion: response.data } });
      }
    }
  } catch (err) {
    console.log(err);
  }

};

export const getReceptoresByEmisor = (token, emisorId) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };
  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: 'getReceptoresByEmisor' } });

  try {
    const response = await agileBilling.get(`/ReceptoresPorEmisor/${emisorId}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        console.log(err.response.data);
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getReceptoresByEmisor, payload: { receptores: response.data } });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    console.log(err);
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }

};

export const getReceptorHacienda = (cedula) => async dispatch => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 5000
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await hacienda.get(`/fe/ae?identificacion=${cedula}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        } else if (err?.code === 'ECONNABORTED') {
          console.log(`[getReceptorHacienda] Timeout: Endpoint did not respond within 5 seconds for cedula: ${cedula}`);
          dispatch({ type: actionTypesEnum.getReceptorHacienda, payload: null });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getReceptorHacienda, payload: response.data });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    console.log(`[getReceptorHacienda] Error: ${err.message}`);
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }

}

export const searchProdbyCabys = (cabys) => async dispatch => {
  const config = {
    headers: { 'Content-Type': 'application/json' }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await hacienda.get(`/fe/cabys?codigo=${cabys}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.searchCabys, payload: { searchCabys: response.data, search: cabys } });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }

}

export const searchProdByDescripcion = (descripcion) => async dispatch => {

  const config = {
    headers: { 'Content-Type': 'application/json' }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await hacienda.get(`/fe/cabys?q=${descripcion}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.searchCabys, payload: { searchCabys: response.data.cabys, search: descripcion } });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }

}

export const duplicarFactura = (factura) => async dispatch => {

  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.duplicarFactura, payload: factura });
  dispatch({ type: actionTypesEnum.loading, payload: false });

}

export const getDireccionEmisor = (idEmisor, token) => async dispatch => {

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.get(`/catalogos/direccionEmisor/${idEmisor}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.direccionEmisor, payload: response.data });
    }

  } catch (err) {
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
}

export const getDireccionReceptor = (idReceptor, token) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.get(`/catalogos/direccionReceptor/${idReceptor}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
      });

    if (response) {
      dispatch({ type: actionTypesEnum.direccionReceptor, payload: response.data });
    }

  } catch (err) {
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
}

export const crearFactura = (token, factura) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: null, message: '' } });
  dispatch({ type: actionTypesEnum.estadoDocumentoElectronico, payload: null });
  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.post(`/FacturaElectronica`, factura, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: false, message: 'Documento creado satisfactoriamente' } });
      dispatch({ type: actionTypesEnum.estadoDocumentoElectronico, payload: response.data });
      dispatch({ type: actionTypesEnum.loading, payload: false });
      dispatch(setInicializarDocumento());
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }
};

export const postNotaCreditoPorEmisor = (token, filter) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await agileBilling.post(`/NotaCreditoPorEmisor`, filter, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getNotaCreditoPorEmisor, payload: null });
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getNotaCreditoPorEmisor, payload: { facturas: response.data } });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }

};

export const crearNotaCredito = (token, factura) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: null, message: '' } });
  dispatch({ type: actionTypesEnum.estadoDocumentoElectronico, payload: null });
  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.post(`/NotaCredito`, factura, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
        }
        console.log(err);
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: false, message: 'Documento creado satisfactoriamente' } });
      dispatch({ type: actionTypesEnum.estadoDocumentoElectronico, payload: response.data });
      dispatch({ type: actionTypesEnum.loading, payload: false });
      dispatch(setInicializarDocumento());
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const postNotaDebitoPorEmisor = (token, filter) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await agileBilling.post(`/NotaDebitoPorEmisor`, filter, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getNotaDebitoPorEmisor, payload: null });
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getNotaDebitoPorEmisor, payload: { facturas: response.data } });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }

};

export const crearNotaDebito = (token, factura) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: null, message: '' } });
  dispatch({ type: actionTypesEnum.estadoDocumentoElectronico, payload: null });
  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.post(`/NotaDebito`, factura, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: false, message: 'Documento creado satisfactoriamente' } });
      dispatch({ type: actionTypesEnum.estadoDocumentoElectronico, payload: response.data });
      dispatch({ type: actionTypesEnum.loading, payload: false });
      dispatch(setInicializarDocumento());
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const postTiquetePorEmisor = (token, filter) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await agileBilling.post(`/TiqueteElectronicoPorEmisor`, filter, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getTiquetePorEmisor, payload: { facturas: response.data } });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }

};

export const crearTiquete = (token, tiquete) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: null, message: '' } });
  dispatch({ type: actionTypesEnum.estadoDocumentoElectronico, payload: null });
  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.post(`/TiqueteElectronico`, tiquete, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: false, message: 'Documento creado satisfactoriamente' } });
      dispatch({ type: actionTypesEnum.estadoDocumentoElectronico, payload: response.data });
      dispatch({ type: actionTypesEnum.loading, payload: false });
      dispatch(setInicializarDocumento());
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const reenviarDocumento = (token, email, clave) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });
  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.get(`/EstadoDocumentos/GetReenviarCorreo/${email}/${clave}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: 'Se presento un error al enviar el documento' } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getErrores, payload: { error: false, message: 'Documento enviado satisfactoriamente' } });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const postConfirmacionFacturas = (token, array) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });
  dispatch({ type: actionTypesEnum.loading, payload: true });
  try {
    const response = await agileBilling.post(`/MensajeReceptor/multiple/`, array, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, 'arrayConfirmacion') } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.confirmacionFacturas, payload: { respuesta: { ...response.data } } });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    console.log(err);
  }

};

export const getConfirmados = (token, ID, fechaIni, fechaFin) => async dispatch => {

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };
  dispatch({ type: actionTypesEnum.loading, payload: true });
  try {
    const response = await agileBilling.get(`/MensajeReceptor/DocConfirmados/${ID}/${fechaIni}/${fechaFin}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: getErrorMessage(err.response.status, 'cantones') } });
          dispatch({ type: actionTypesEnum.loading, payload: false });
          dispatch({ type: actionTypesEnum.getDocumentosConfirmados, payload: [] });
        }
        console.log(err.response.data);
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getDocumentosConfirmados, payload: response.data });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    console.log(err);
  }
};

export const clearConfirmados = () => dispatch => {
  dispatch({ type: actionTypesEnum.getDocumentosConfirmados, payload: [] });
}

export const getReporteToChart = (token, emisorId, fechaInicio, fechaFin) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });
  dispatch({ type: actionTypesEnum.dashbord, payload: null });
  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.get(`/Reportes/TotalVentas/${emisorId}/${fechaInicio}/${fechaFin}`, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: 'Se presento un problema al graficar' } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.dashbord, payload: response.data });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: 'Se presento un problema al graficar' } });
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const crearFacturaCompra = (token, factura) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: null, message: '' } });
  dispatch({ type: actionTypesEnum.estadoDocumentoElectronico, payload: null });
  dispatch({ type: actionTypesEnum.loading, payload: true });

  try {
    const response = await agileBilling.post(`/FacturaElectronicaCompra`, factura, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
        }
        console.log(err);
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: false, message: 'Documento creado satisfactoriamente' } });
      dispatch({ type: actionTypesEnum.estadoDocumentoElectronico, payload: response.data });
      dispatch({ type: actionTypesEnum.loading, payload: false });
      dispatch(setInicializarDocumento());
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.getNuevoDocumentoErrores, payload: { error: true, message: 'Se presento un error al crear el documento' } });
  }
  dispatch({ type: actionTypesEnum.loading, payload: false });
};

export const postFacturaCompraPorEmisor = (token, filter) => async dispatch => {
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  dispatch({ type: actionTypesEnum.loading, payload: true });
  dispatch({ type: actionTypesEnum.getErrores, payload: { error: null, message: '' } });

  try {
    const response = await agileBilling.post(`/FacturaCompraPorEmisor`, filter, config)
      .catch(err => {
        if (err?.response) {
          dispatch({ type: actionTypesEnum.getFacturaCompraPorEmisor, payload: null });
          dispatch({ type: actionTypesEnum.getErrores, payload: { error: true, message: getErrorMessage(err.response.status, '') } });
        }
        dispatch({ type: actionTypesEnum.loading, payload: false });
      });

    if (response) {
      dispatch({ type: actionTypesEnum.getFacturaCompraPorEmisor, payload: { facturas: response.data } });
      dispatch({ type: actionTypesEnum.loading, payload: false });
    }

  } catch (err) {
    dispatch({ type: actionTypesEnum.loading, payload: false });
  }

};
